import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiSwitch from '@material-ui/core/Switch';

import {
  secondary300,
  secondary200,
} from '../../../src/themes/colors';

const styles = theme => ({
  root: {
    width: '2.5rem',
    height: '1.5rem',
    padding: 0,
    margin: ({ isInTable }) => (isInTable ? '8px 8px 8px 0' : theme.spacing(1)),
  },
  switchBase: {
    padding: '0.219rem',
    '&$checked': {
      transform: 'translateX(1rem)',
      color: theme.palette.secondary['0'],
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: theme.palette.secondary['0'],
      border: `0.375rem solid ${theme.palette.white}`,
    },
  },
  thumb: {
    width: '1rem',
    height: '1rem',
    boxShadow: theme.shadows[1],
  },
  track: {
    borderRadius: '1rem',
    backgroundColor: secondary300,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
  sizeSmall: {
    width: '2rem',
    height: '1.125rem',
    '& $switchBase': {
      '&$checked': {
        transform: 'translateX(0.875rem)',
      },
    },
    '& $thumb': {
      width: '0.625rem',
      height: '0.625rem',
    },
  },
  disabled: {
    '&$switchBase': {
      color: theme.palette.secondary['0'],
      '& $track': {
        backgroundColor: secondary200,
        opacity: 1,
      },
    },
  },
});

const Switch = (props) => {
  const { classes, controlled } = props;

  const [internalChecked, setInternalChecked] = React.useState(props.checked);
  React.useEffect(() => {
    setInternalChecked(props.checked);
  }, [props.checked]);

  const handleOnChange = async (e) => {
    // eslint-disable-next-line prefer-destructuring
    const checked = e.target.checked;
    if (!controlled) {
      setInternalChecked(checked);
    }
    try {
      await props.onChange(e);
    } catch (error) {
      setInternalChecked(!checked);
    }
  };

  return (
    <MuiSwitch
      {...props}
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      checked={internalChecked}
      onChange={handleOnChange}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        sizeSmall: classes.sizeSmall,
        disabled: classes.disabled,
      }}
    >
      {props.children}
    </MuiSwitch>
  );
};

export default withStyles(styles)(Switch);
